import sensors from 'static/js/sensorsdata.es6.min'
import Vue from 'vue'
import { isH5ByAgent, objectKeyToLow } from '~/utils/utils'

/**
 * 数据埋点分析模块
 * @param isHMR
 * @param req
 * @returns {boolean}
 *
 * TODO 还差用户关联 要根据业务看是否需要  属性层的分层设置 需要根据业务划分 登录 数据校验 数据加密等都缺失  还有插件设置
 * 文档地址 https://klteeqb691.feishu.cn/docx/YOL4d8Fsuo49X9xU7RUcRYJ7neg
 */
export default function ({ isHMR, req }) {
  // 热更新状态下 不处理任务
  if (isHMR) return false
  // 是否是生成环境
  const isPro = process.env.NODE_ENV === 'production'
  const isOpenSys = {
    openClickMap: true, // 是否开启全埋点自动采集$webCLick功能
    openStayMap: false, // 是否开启全埋点自动采集$WebStay功能
    openPageViewMap: true // 是否开启全埋点自动采集$pageView 功能
  }
  const getSys = (boolean = true) => boolean ? 'default' : 'not_collect'

  // 地址配置
  const proLinks = {
    test: 'https://d2lcl5kaaeap3q.cloudfront.net/sa?project=default',
    prod: 'https://d2lcl5kaaeap3q.cloudfront.net/sa?project=production'
  }

  /**
   * 规则格式检测并返回新的属性值
   * @param attributes
   * @returns {{}|{}}
   */
  const ruleCheck = (attributes) => {
    // 规则：所有的属性名必须全部转小写
    // 规则：属性值布尔值全部转 1 0
    const newAttrs = objectKeyToLow(attributes)
    // TODO  其他的检测机制
    return newAttrs
  }
  const analyzeConfig = {
    server_url: isPro ? proLinks.prod : proLinks.test,
    // is_track_single_page: false, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
    use_client_time: true,
    send_type: 'beacon', // image => get, 1.10后ajax和beacon => post
    show_log: !isPro,
    heatmap: {
      // 是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
      clickmap: getSys(isOpenSys.openClickMap),
      // 是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
      scroll_notice_map: getSys(isOpenSys.openStayMap)
    }
  }

  // 初始化
  sensors.init(analyzeConfig)

  // 代码埋点追踪事件 trackName => string  attributes => object
  sensors.$setTrack = function (trackName, attributes) {
    sensors.track(trackName, ruleCheck(attributes))
  }
  // sensor quick
  sensors.$setQuick = function (quickName, attributes) {
    sensors.quick(quickName, ruleCheck(attributes))
  }
  // 设置公共属性  attributes => object
  sensors.$registerPage = function (attributes) {
    sensors.registerPage(ruleCheck(attributes))
  }
  // 默认注册全局属性
  sensors.$registerPage({
    // is_h5: isH5ByAgent(navigator.userAgent) ? 'H5' : 'Web'
    is_h5: isH5ByAgent(navigator.userAgent)
  })

  // 用于采集$pageView事件
  isOpenSys.openPageViewMap && sensors.$setQuick('autoTrack', {
    is_h5: isH5ByAgent(navigator.userAgent)
  })

  // console.log('sensors ========>', sensors, sensors.getPresetProperties(), navigator)

  Vue.prototype.$sensors = sensors
}
